import {Injectable} from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';



@Injectable()
export class BlogtagService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allBlogTag(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogtag', "").then(data => {
            if (data) {
                return data.data;
            }
        })
    }
   
    iBlogPost(Post): Promise<any> {
        return this.httpmanagerService.HttpPost('blogpost', JSON.stringify(Post), "").then(data => {
            return data;
        })
    }
    DescriptPassword(currentPassword) {
        return this.httpmanagerService.DecriptPass(currentPassword);
    }
    
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/blogtag/blogtag.service.ts